import { GET_LAB_STUDIES } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getLabStudies = createAsyncThunk('getLabStudies', async (payload = {}) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${GET_LAB_STUDIES}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch analytics details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default getLabStudies;
